export default __webpack_public_path__ + "static/media/arco-ameaca.17dd4ee0.webp";